<div class="container mt-4">
    <button class="btn btn-primary mb-3" (click)="addObjectGroup()">Add Object Group</button>

    <div class="card p-3 mb-3">
        <div class="row g-2 align-items-end">
            <div class="col-md-6">
                <label>Search</label>
                <input
                    type="text"
                    class="form-control"
                    placeholder="Short code, name, or remarks…"
                    [(ngModel)]="searchText"
                    (ngModelChange)="onSearchChange()"
                />
            </div>
            <div class="col-md-6 text-muted small">
                {{ displayedObjectGroups.length }} of {{ objectGroups.length }} object group(s)
            </div>
        </div>
    </div>

    <table class="table table-bordered table-hover">
        <thead>
            <tr>
                <th role="button" (click)="setSort('objGroupShortcode')">Short Code{{ sortIndicator('objGroupShortcode') }}</th>
                <th role="button" (click)="setSort('objGroupName')">Name{{ sortIndicator('objGroupName') }}</th>
                <th role="button" (click)="setSort('objGroupRemarks')">Remarks{{ sortIndicator('objGroupRemarks') }}</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let objectGroup of displayedObjectGroups">
                <td>{{ objectGroup.objGroupShortcode }}</td>
                <td>{{ objectGroup.objGroupName }}</td>
                <td>{{ objectGroup.objGroupRemarks }}</td>
                <td>
                    <button class="btn btn-secondary" (click)="editObjectGroupLines(objectGroup)">Edit Lines</button>
                </td>
            </tr>
            <tr *ngIf="displayedObjectGroups.length === 0">
                <td colspan="4" class="text-muted text-center">No object groups match your search.</td>
            </tr>
        </tbody>
    </table>
</div>
